
import { capitalizeFirstLetter } from 'pawpaddock-common/data'

export default {
  name: 'ErrorSummary',

  props: {
    validationErrors: {
      type: Object,
      default: () => ({})
    },

    apiModels: {
      type: Array,
      default: () => []
    },

    submissionAttempted: {
      type: Boolean,
      default: false
    },

    withTitle: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    compIsVisible() {
      return (
        (this.compErrors.length && this.submissionAttempted) ||
        this.compHasFatalError ||
        this.compApiErrors.length > 0
      )
    },

    compErrors() {
      const errors = []

      Object.entries(this.validationErrors).forEach(([fieldName, fieldErrors]) => {
        if (fieldErrors.length > 0) {
          errors.push(fieldErrors[0])
        }
      })

      return errors
    },

    compHasFatalError() {
      let hasFatalErrors = false

      this.apiModels.forEach(apiModel => {
        if (!apiModel || !apiModel?.response) {
          return
        }

        if (apiModel.response.code === 500) {
          hasFatalErrors = true
        }
      })

      return hasFatalErrors
    },

    compFatalErrorMessage() {
      let errorMessage = null

      this.apiModels.forEach(apiModel => {
        if (!apiModel || !apiModel?.response) {
          return
        }

        if (apiModel.response.code === 500 && apiModel.response.message) {
          errorMessage = capitalizeFirstLetter(apiModel.response.message)
        }
      })

      return errorMessage
    },

    compApiErrors() {
      const errorMessages = []

      this.apiModels.forEach(apiModel => {
        if (!apiModel || !apiModel?.response) {
          return
        }

        if (apiModel.response.status === 'error' && apiModel.response.message) {
          errorMessages.push(apiModel.response.message)
        }

        if ([500, 429].includes(apiModel.response.code) && errorMessages.length < 1) {
          errorMessages.push(this.$t('somethingWentWrong'))
        }
      })

      // Remove duplicate error messages from array
      return [...new Set(errorMessages)]
    }
  },

  watch: {
    compIsVisible(isVisibleNow, wasVisiblePreviously) {
      if (isVisibleNow && !wasVisiblePreviously) {
        setTimeout(() => {
          this.$scroll.intoViewIfNeeded(this.$el)
        }, 500)
      }
    }
  },

  methods: {
    scrollToField(fieldName) {
      this.$log.debug('Scrolling to', fieldName)

      if (fieldName === 'customErrors' && document.querySelector('form')) {
        this.$scroll.intoViewIfNeeded(document.querySelector('form'), false, 'start')
      } else if (document.querySelector(`[name='${fieldName}']`)) {
        this.$scroll.intoViewIfNeeded(document.querySelector(`[name='${fieldName}']`))
      }
    }
  }
}
